import moment from 'moment'
import React from 'react'

interface Props {
  value: string | Date
  format?: string
}

export const FormattedDate: React.FC<Props> = (props) => {
  return <span>{moment(props.value).format(props.format || 'LLL z')}</span>
}
